import { withIcon } from "../Icon"

export const IconHome = withIcon(
  '<path fill="none" stroke="currentColor" stroke-width="1.5" d="M4.5 23a2.4 2.4 0 0 1-1.765-.738A2.43 2.43 0 0 1 2 20.486V9.17c0-.398.089-.775.266-1.131.177-.356.421-.65.734-.88l7.5-5.657c.23-.168.469-.293.719-.377.25-.084.51-.126.781-.126.27 0 .531.042.781.126.25.084.49.21.719.377L21 7.16c.313.23.558.524.735.88.177.356.265.733.265 1.131v11.315c0 .691-.245 1.283-.734 1.776A2.404 2.404 0 0 1 19.5 23h-5v-8.8h-5V23h-5Z" />',
)
